import React, { useMemo, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Toolbar from 'fulogics-ui-web/dist/layout/dx/Toolbar/Toolbar';
import { Item } from 'devextreme-react/toolbar';
import OrderDetails from '../../components/order-details/OrderDetails';
import { orderScreenOrderInfoDrawerToolBarId } from './inspectorOptions';
import style from './OrdersScreenComponent.module.scss';
import classNames from 'classnames';
import { useDrawerContext } from 'fulogics-ui-web/dist/layout/dx/Drawer/DrawerContext';
import { OrderDetailsDrawerContextType } from './OrdersScreen';
import enOrderState from '../../../api/enums/enOrderState';
import { dxButtonOptions } from 'devextreme/ui/button';

function renderTitle(args: any) {
    return <div className={style.title}>{args.options.title}</div>;
}

function renderEditLink(args: any) {
    return <Link to={`/order-edit/${args.options.id}`}>{args.options.title}</Link>;
}

const OrderDetailsDrawerContent = memo(() => {
    const { data, onCloseDrawerClick } = useDrawerContext<OrderDetailsDrawerContextType>();
    const { t, ready } = useTranslation();

    const buttonOptions = useMemo(
        () => ({
            className: style.closeButton,
            icon: 'close',
            onClick: onCloseDrawerClick,
        }),
        [onCloseDrawerClick]
    );

    const isDraft = data?.orderItem?.state === enOrderState.Draft;

    const handleCancel = () => {
        if (isDraft) {
            data?.removeItem?.(data?.orderItem?.id);
        }
    };

    const titleOptions = ready
        ? {
              title:
                  t('OrderScreen:orderDetailsModalTitle') + ' #' + data?.orderItem?.wmsExternalId,
          }
        : {};

    const editLinkOptions =
        ready && data?.orderItem?.id
            ? {
                  title: t('OrderScreen:editOrder'),
                  id: data?.orderItem?.id,
              }
            : {};

    const deleteButtonOptions: dxButtonOptions = ready
        ? {
              text: t('OrderScreen:delete'),
              type: 'danger',
              stylingMode: 'text',
              onClick: handleCancel,
          }
        : {};

    const canEdit =
        data?.orderItem?.state === enOrderState.Draft &&
        (!data?.orderItem?.currentEditing?.editingBy?.id ||
            data?.orderItem?.currentEditing?.editingBy?.id === data?.currentUserId);

    return (
        <div className={classNames(style.aroundToolbar)}>
            <Toolbar className={style.toolBar} inspectorId={orderScreenOrderInfoDrawerToolBarId}>
                <Item location="before" render={renderTitle} options={titleOptions} />
                {canEdit && (
                    <Item location="before" render={renderEditLink} options={editLinkOptions} />
                )}
                {canEdit && (
                    <Item location="before" widget="dxButton" options={deleteButtonOptions} />
                )}
                <Item location="after" widget="dxButton" options={buttonOptions} />
            </Toolbar>
            <OrderDetails data={data?.orderItem} />
        </div>
    );
});

export default OrderDetailsDrawerContent;
